import { Col, Row, Skeleton, Tag } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Item } from "../../../interface/finishedGoods";

interface ICreateSales {
  setId: (data: string) => void;
  setActive: (data: boolean) => void;
  data: Item;
  isLoading: boolean;
}
export const FinishedGoodsPreview: React.FC<ICreateSales> = ({
  setId,
  setActive,
  data,
  isLoading,
}) => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const ratingData = [
    "Cost",
    "Quality",
    "Credit terms",
    "Reliability",
    "Logistic chain",
    "Communication",
  ];

  useEffect(() => {
    if (id) {
      setId(data?.finished_goods_id as string);
      setActive(data?.is_active as boolean);
    }
  }, [id, data?.finished_goods_id]);

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <div>
          <div className="sales-detail-border-main ">
            <Row className="w-full">
              <div className="sales-detail-border flex flex-col gap-2 w-full">
                <div className="sales-detail-placeholder">Item Name</div>
                <div className="sales-detail-sub-title common-work-break">
                  {data?.name?.name}
                </div>
              </div>
            </Row>
            <Row className="w-full">
              <div className="sales-detail-border flex flex-col gap-2 w-full">
                <div className="sales-detail-placeholder">Category</div>
                <div className="sales-detail-sub-title common-work-break">
                  <div className="flex gap-2">
                    {data?.category?.breadcrumb &&
                      data?.category?.breadcrumb?.map((item: any, index) => (
                        <div className="flex gap-2">
                          <span>{item}</span>
                          {data?.category?.breadcrumb &&
                            index !== data.category.breadcrumb.length - 1 && (
                              <img
                                src="/assets/rightArrow.svg"
                                alt="Right Arrow"
                              />
                            )}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </Row>
            <Row>
              <Col span={24} md={{ span: 12 }}>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Type</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.type === "refurbished_goods"
                      ? "Refurbished"
                      : "New Goods"}
                  </div>
                </div>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Model</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.model?.name}
                  </div>
                </div>
              </Col>
              <Col span={24} md={{ span: 12 }}>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Brand</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data.brand?.name ? data?.brand?.name : "-"}
                  </div>
                </div>
                <div className=" flex flex-col gap-2 overallrating">
                  <div className="sales-detail-placeholder">Grade</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.grade?.name ? data?.grade?.name : "-"}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24} md={{ span: 12 }}>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Color</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.color?.name ? data?.color?.name : "-"}
                  </div>
                </div>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Safety Stock</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.safety_stock ? data?.safety_stock : "-"}
                  </div>
                </div>
              </Col>
              <Col span={24} md={{ span: 12 }}>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Stock Qty</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.stock_quantity ? data?.stock_quantity : "-"}
                  </div>
                </div>
                <div className=" flex flex-col gap-2 overallrating">
                  <div className="sales-detail-placeholder">
                    Demand Forecast
                  </div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.demand_forcast ? data?.demand_forcast : "-"}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24} md={{ span: 12 }}>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">
                    New Order Demand
                  </div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.new_order_demand ? data?.new_order_demand : "-"}
                  </div>
                </div>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">EOQ</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.new_order_demand ? data?.new_order_demand : "-"}
                  </div>
                </div>
              </Col>
              <Col span={24} md={{ span: 12 }}>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Lead Time</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.lead_time ? data?.lead_time : "-"}
                  </div>
                </div>
                <div className=" flex flex-col gap-2 overallrating">
                  <div className="sales-detail-placeholder">Stock Required</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.stock_required ? data?.stock_required : "-"}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24} md={{ span: 12 }}>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">
                    Stock UpdatedOn
                  </div>
                  <div className="sales-detail-sub-title common-work-break">
                    {moment(data?.modified_date).format("DD/MM/YYYY")}
                  </div>
                </div>
              </Col>
              <Col span={24} md={{ span: 12 }}>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">
                    Inventory Suggestion
                  </div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.stock_quantity > data?.cutoff_stock ? (
                      <Tag color="green">Sufficient</Tag>
                    ) : data?.stock_quantity === data?.cutoff_stock ? (
                      <Tag color="orange">Just Sufficient</Tag>
                    ) : (
                      <Tag color="red">Insufficient</Tag>
                    )}
                  </div>
                </div>
              </Col>
              <Col span={24} md={{ span: 12 }}>
                <div className="sales-detail-border flex flex-col gap-2">
                  <div className="sales-detail-placeholder">Dead Stock</div>
                  <div className="sales-detail-sub-title common-work-break">
                    {data?.dead_stock ? data?.dead_stock : "-"}
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="w-full">
              <div className="sales-detail-border flex flex-col gap-2 w-full">
                <div className="sales-detail-placeholder">Remarks</div>
                <div className="sales-detail-sub-title  common-work-break">
                  {data?.remarks ? data?.remarks : "-"}
                </div>
              </div>
            </Row>
          </div>
          {data?.specification?.length > 0 && (
            <div>
              <Row className="mt-24p">
                <Col span={8} className="sales-detail-border">
                  <b>Specification</b>
                </Col>
                <Col span={8} className="sales-detail-border">
                  <b>Dimension</b>
                </Col>
                <Col span={8} className="sales-detail-border">
                  <b>Unit</b>
                </Col>
              </Row>

              {data?.specification?.map(
                (specification: any, specIndex: number) => (
                  <Row key={specIndex}>
                    {/* Material (Specification Name) */}
                    <Col span={8} className="sales-detail-border">
                      {specification?.specification_name}
                    </Col>

                    {/* Dimension */}
                    <Col span={8} className="sales-detail-border">
                      {specification?.valueFields?.map(
                        (field: any, fieldIndex: number) => (
                          <div key={fieldIndex}>
                            {field?.dimension_value?.join(", ") || "N/A"}
                          </div>
                        )
                      )}
                    </Col>

                    {/* Unit */}
                    <Col span={8} className="sales-detail-border">
                      {specification?.valueFields?.map(
                        (field: any, fieldIndex: number) => {
                          const unitName = specification?.unitOptions?.find(
                            (option: any) => option.value === field.unit
                          )?.label;

                          return <div key={fieldIndex}>{unitName || "-"}</div>;
                        }
                      )}
                    </Col>
                  </Row>
                )
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default FinishedGoodsPreview;
